// Basic
import PropTypes from 'prop-types';
// Components
import DetailsGrid from '@/common-utils/components/renders/detailsGrid/DetailsGrid';
// Common
import rentalFilesFields from '../../fields/rentalFilesFields';
import RENTAL_EVENT_TYPES from '../../enum/RentalEventTypes';
import TRANSACTION_TYPES from '../../../terminals/enums/TransactionType';
import BANK_CODES from '@/app/modules/contracts/enums/BankCodes';

/**
 * @param {Object} root0
 * @param root0.rentalFile
 * @returns {JSX} RentalFileInfosPanel
 */
const RentalFileInfosPanel = ({ rentalFile }) => {
    // Constants
    const currency = rentalFile[rentalFilesFields.CURRENCY.key];

    // Functions
    // Get the bank code with the bank label
    const getBankCode = () => {
        const bankCode = rentalFile[rentalFilesFields.BANK_CODE.key];
        const bankCodeItem = BANK_CODES.find(code => code.bankCode === bankCode);
        return bankCodeItem ? `${bankCode} - ${bankCodeItem.bankLabel}` : bankCode;
    };
    // Get the amount from the rental events by event name
    const getAmount = (eventName) => {
        /*
        Get the amount from the rental events by event name
        - Filter the rental events by event name
        - Filter the rental events by transaction type debit only (no reversal)
        - Reduce the rental events by amount
        */
        return rentalFile?.[rentalFilesFields.RENTAL_EVENTS.key]
            .filter(event =>
                // Filter the rental events by event name and transaction type debit only (no reversal)
                event.eventType === eventName && event.transactionType !== TRANSACTION_TYPES.DEBIT_REVERSAL.name)
            .reduce((acc, event) => acc + event.amount, 0) ?? 0;
    };

    // Define the keys for the details grid
    const detailsKeys = {
        STATUS: rentalFilesFields.STATUS,
        INITIAL_AMOUNT: rentalFilesFields.INITIAL_AMOUNT,
        FINAL_AMOUNT: rentalFilesFields.FINAL_AMOUNT,
        FILE_NUMBER: rentalFilesFields.FILE_NUMBER,
        OPENING_DATE: rentalFilesFields.OPENING_DATE,
        CLOSING_DATE: rentalFilesFields.CLOSING_DATE,
        CONTRACT: rentalFilesFields.CONTRACT,
        RANK: rentalFilesFields.RANK,
        BANK_CODE: rentalFilesFields.BANK_CODE
    };

    // Add initial amount and final amount with currency to the rental file object
    const formattedData = {
        ...rentalFile,
        bankCode: getBankCode(),
        initialAmount: {
            amount: getAmount(RENTAL_EVENT_TYPES.PREAUTHORIZATION.name),
            currency: currency
        },
        finalAmount: {
            amount: getAmount(RENTAL_EVENT_TYPES.REMOTE_COLLECTION.name),
            currency: currency
        }
    };

    return (
        <DetailsGrid
            data={formattedData}
            fields={detailsKeys}
            columnsNumber={3}
        />
    );
};

RentalFileInfosPanel.propTypes = {
    rentalFile: PropTypes.object.isRequired
};

export default RentalFileInfosPanel;